import { whatsNewLastUpdateDate } from "./whatsnew-asof.json";
import { HttpClient } from "@/App/services/httpClient/HttpClient";
import type { User } from "@/App/user/User";

export const WhatsNewService = {
  whatsNewDate(): string {
    return whatsNewLastUpdateDate;
  },
  setLastWhatsNewDate(id: string): Promise<User> {
    return HttpClient.patch<User>({
      path: `/users/${id}/whats-new`,
      body: { lastSeen: new Date().toISOString() },
    });
  },
};
